import React from "react";
import "./Home.css";
import Particle from "../../Components/Particle";
import { Route } from "react-router-dom";
import Typing from "react-typing-animation";

export default function Home() {
  return (
    <div className="home__content">
      <Particle />
      <div className="home__content__text">
        <Typing cursorClassName="custom" cursor={<span>_</span>} speed={80}>
          <h1>Hi,</h1>
          <h1>I'm Vaibhav,</h1>
          <h1>Web developer.</h1>
          <Typing.Backspace count={29} />
          <h1>Learning</h1>
          <h1>and</h1>
          <h1>Exploring new things.</h1>
          <Typing.Backspace count={32} />
          <h1>Hi,</h1>
          <h1>I'm Vaibhav,</h1>
          <h1>Web developer.</h1>
        </Typing>
      </div>

      <Route
        render={({ history }) => (
          <button
            className="home__content__button"
            type="button"
            onClick={() => {
              history.push("/Contact");
            }}
          >
            Contact me!
          </button>
        )}
      />
    </div>
  );
}
